<template>
    <company-menu :onLogout="logout" :companyId="companyId" :companyFullName="companyFullName" />
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import CompanyMenu from './CompanyMenu';

export default {
    name: 'company-menu-container',
    components: {
        CompanyMenu,
    },
    methods: {
        ...mapActions('auth', ['logout']),
        ...mapActions('profile', ['fetchProfileShortInfo', 'fetchProfile']),
    },
    created() {
        this.fetchProfileShortInfo();
    },
    computed: {
        ...mapGetters('profile', ['companyId', 'companyFullName']),
    }
}
</script>



// WEBPACK FOOTER //
// CompanyMenuContainer.vue?43eb4b17